/**
 * Copyright © Veeam Software Group GmbH.
 */

import { PublicCloudPlatformTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type PublicCloudPlatformTypes = PublicCloudPlatformTypeRepresentation;
export const PublicCloudPlatformTypes = PublicCloudPlatformTypeRepresentation;
